import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d6953bfa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "px-2" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "interventions-info-list" }, [
  /*#__PURE__*/_createElementVNode("li", null, "A special online activity is slated for each of the below. This will provide explanations and 'blocked' practice."),
  /*#__PURE__*/_createElementVNode("li", null, "Instead, the teacher can step in first to provide explicit teaching, recording this as a 'targeted intervention'. To do this, click on the item.")
], -1))
const _hoisted_3 = {
  class: "mb-4 text-gray-900",
  style: {"font-family":"'Inter', sans-serif","font-weight":"400","font-size":"14px","line-height":"20px"}
}
const _hoisted_4 = { style: {"font-weight":"700"} }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "italic" }, "At least two errors.", -1))
const _hoisted_7 = {
  key: 0,
  class: "list-decimal list-outside ml-5 space-y-1 text-gray-700"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "font-bold italic" }
const _hoisted_10 = {
  key: 1,
  class: "interventions-empty"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-500 text-sm" }, "No interventions needed.", -1))
const _hoisted_12 = [
  _hoisted_11
]

import { computed, h } from 'vue'
import { useRouter } from 'vue-router'
import LingoModalComponent from '@/modules/main/components/manage/LingoModalComponent.vue'
import RLIconComponent from '@/components/global/RLIconComponent.vue'
import { KnowledgeComponent } from '@/interfaces/lingo.interfaces'


export default /*#__PURE__*/_defineComponent({
  __name: 'InterventionsModal',
  props: {
    isOpen: { type: Boolean },
    studentName: {},
    studentId: {},
    interventionKCs: {}
  },
  emits: ['close'],
  setup(__props: any, { emit }) {

const props = __props;

const StudentsIcon = () => h(RLIconComponent, { icon: 'rl-grey-students' })




const router = useRouter()

const sortedKCs = computed(() =>
  [...props.interventionKCs].sort((a, b) => a.word.localeCompare(b.word))
)

const modalTitle = computed(() => `Interventions for ${props.studentName}`)
const modalSubtitle = computed(() => `Interventions: ${sortedKCs.value.length}`)

function close() {
  emit('close')
}

function navigateToKC(kc: KnowledgeComponent) {
  close()
  const threadPath = kc.type === 'vocabulary' ? 'lingo-vocabulary-word' : 'lingo-spelling-word'
  router.push(`/main/${threadPath}/${props.studentId}/${kc._id}`)
}

function kcPrefix(kc: KnowledgeComponent): string {
  return kc.type === 'vocabulary' ? 'Know the word: ' : 'Spell the word: '
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(LingoModalComponent, {
    modelValue: _ctx.isOpen,
    "onUpdate:modelValue": close,
    title: modalTitle.value,
    subtitle: modalSubtitle.value,
    icon: StudentsIcon,
    size: "640",
    centered: ""
  }, {
    footer: _withCtx(() => [
      _createElementVNode("button", {
        onClick: close,
        class: "w-full px-4 py-2 border border-gray-300 rounded-lg text-gray-700 font-medium hover:bg-gray-50 transition shadow-sm"
      }, " Close ")
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("p", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, "Learning (" + _toDisplayString(sortedKCs.value.length) + ")", 1),
          _hoisted_5,
          _hoisted_6
        ]),
        (sortedKCs.value.length > 0)
          ? (_openBlock(), _createElementBlock("ol", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedKCs.value, (kc) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: kc._id,
                  class: "pl-1"
                }, [
                  _createElementVNode("button", {
                    onClick: ($event: any) => (navigateToKC(kc)),
                    class: "text-[#602DE6] hover:underline hover:text-purple-900 focus:outline-none text-left"
                  }, [
                    _createTextVNode(_toDisplayString(kcPrefix(kc)), 1),
                    _createElementVNode("span", _hoisted_9, _toDisplayString(kc.word), 1)
                  ], 8, _hoisted_8)
                ]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title", "subtitle"]))
}
}

})